import React from 'react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-173">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" data-id="element-174"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-175">
        <h2 className="text-3xl sm:text-6xl font-serif font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight" data-id="element-176">
          Strategic Launch Offer for Australia
        </h2>

        {/* Featured Card */}
        <div className="bg-white rounded-xl sm:rounded-3xl border border-border-light shadow-[0_10px_40px_rgba(201,137,155,0.1)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-177">
          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-primary text-white font-bold text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_4px_15px_rgba(201,137,155,0.3)]" data-id="element-178">
            ⭐ THE PREMIUM VAULT
          </div>

          <div className="space-y-3 sm:space-y-5 mb-6 sm:mb-10 text-sm sm:text-lg mt-4" data-id="element-179">
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-2 sm:pb-3" data-id="element-180">
              <span data-id="element-181">Educational Collection (6 Elite Volumes)</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-182">
                Value $197
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-2 sm:pb-3" data-id="element-183">
              <span data-id="element-184">Assessment Registry & Clinical Sheets</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-185">
                Value $87
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-2 sm:pb-3" data-id="element-186">
              <span data-id="element-187">Dynamic Pilates & Small Props Manual</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-188">
                Value $119
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-2 sm:pb-3" data-id="element-189">
              <span data-id="element-190">6 Exclusive Bonuses</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-191">
                Value $149
              </span>
            </div>
            <div className="flex justify-between text-text-main font-black pt-2 sm:pt-4 text-base sm:text-xl" data-id="element-192">
              <span data-id="element-193">TOTAL IF BOUGHT SEPARATELY:</span>
              <span className="text-badge-red line-through" data-id="element-194">$552</span>
            </div>
          </div>

          {/* Price reveal */}
          <div className="text-center mb-4 sm:mb-8 bg-bg-main border border-border-light py-4 sm:py-8 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-195">
            <p className="text-primary font-bold mb-1 sm:mb-2 text-xs sm:text-base" data-id="element-196">
              LIMITED TIME LAUNCH PRICE:
            </p>
            <div className="text-text-main font-serif font-black text-4xl sm:text-7xl tracking-tighter" data-id="element-197">
              $29.00 AUD
            </div>
            <div className="text-text-sec text-[10px] sm:text-sm font-medium mt-2" data-id="element-198">
              (One-time payment — Lifetime Access to the Vault)
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-primary font-bold text-[10px] sm:text-sm bg-primary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-primary/20 mx-auto mb-4 sm:mb-6" data-id="element-199">
            ⏰ Price will increase once the launch window closes
          </span>

          <a href="https://australia.edulabs.online/cart/43402945331318:1" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'The Pilates Pack — Australian Edition',
              content_type: 'product',
              value: 29.0,
              currency: 'AUD'
            });
          }
        }} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black text-base sm:text-xl py-4 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_8px_25px_rgba(16,185,129,0.25)] mb-3 sm:mb-6" data-id="element-200">
            👉 YES! I WANT THE COMPLETE PILATES PACK
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-201">
            <span data-id="element-202">💳 Secure Australian Payment</span>
            <span data-id="element-203">•</span>
            <span data-id="element-204">⚡ Instant Digital Delivery</span>
            <span data-id="element-205">•</span>
            <span data-id="element-206">🛡️ 14-Day Guarantee</span>
          </p>
        </div>
      </div>
    </section>;
}